import {
  ITutorialJourneyWithActivators,
  TutorialJourneyActivatorDto,
  TutorialJourneyWithActivators,
} from "@growth-machine-llc/stridist-api-client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { TUTORIAL_ACTIVATORS_QUERY_KEY } from "../journey/TutorialJourneysList";
import TutorialJourneyActivatorsService from "../../../services/TutorialJourneyActivatorsService";

export function useCreateTutorialJourneyActivator() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: TutorialJourneyActivatorsService.createTutorialJourneyActivator,
    onSuccess: (newActivator) => {
      queryClient.setQueryData<ITutorialJourneyWithActivators>(
        [TUTORIAL_ACTIVATORS_QUERY_KEY],
        (oldData) => {
          const previousData = oldData || { activators: [], journeys: [] };
          return {
            ...previousData,
            activators: [
              newActivator as unknown as TutorialJourneyActivatorDto,
              ...previousData.activators,
            ],
          };
        },
      );
      queryClient.invalidateQueries({
        queryKey: [TUTORIAL_ACTIVATORS_QUERY_KEY],
      });
    },
  });
}
